export default "__VITE_ASSET__BZKwJDl4__"